/**
 * "Send a DM" picker data (APS-253). GET /integrations/:athleteId/dm-targets
 * lists the schools on the athlete's lists with a coach whose X handle the
 * family can see. A server without the route answers 404, so this resolves to
 * null and the "Send a DM" option stays hidden.
 */
import { BACKEND_CONFIG } from '../config/backendConfig';

export interface DMTargetCoach {
  production_id: number;
  coach_name: string;
  title: string | null;
  position: string | null;
  /** No @, no spaces. */
  twitter_handle: string;
}

export interface DMTargetSchool {
  school_id: number;
  name: string;
  logo_url: string | null;
  category: 'dream' | 'target' | 'safety' | null;
  coaches: DMTargetCoach[];
}

export interface DMTargets {
  dm_targets: DMTargetSchool[];
  /** Free families: schools on their lists with X coaches they have not unlocked. */
  locked_school_count: number;
}

export async function fetchDmTargets(token: string, athleteId: string): Promise<DMTargets | null> {
  if (!token || !athleteId) return null;
  try {
    const res = await fetch(
      `${BACKEND_CONFIG.baseURL}/integrations/${encodeURIComponent(athleteId)}/dm-targets`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (!res.ok) return null;
    const data = await res.json().catch(() => null);
    if (!data || !Array.isArray(data.dm_targets)) return null;
    return {
      dm_targets: data.dm_targets as DMTargetSchool[],
      locked_school_count: Number(data.locked_school_count) || 0,
    };
  } catch {
    return null;
  }
}
